import type { CityConfig } from "../city-template/types";

export const bowlingGreenOhConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Wood County Probate Court", href: "https://www.woodcountyohio.gov/probate-court", description: "Wood County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Wood County Clerk of Courts", href: "https://www.woodcountyohio.gov/clerk-of-courts", description: "Wood County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Bowling Green",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "bowling-green-oh",
  route: "/cities/bowling-green-oh",
  title: "Emergency Passport Bowling Green, OH | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Bowling Green, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wood County and the Bowling Green State University area including Perrysburg, Rossford, and Northwood. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Bowling Green, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Bowling Green and Wood County travelers — including BGSU students and faculty — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Bowling%20Green%20Ohio%20historic%20downtown%20with%20charming%20brick%20buildings%20and%20Bowling%20Green%20State%20University%20campus%20visible%20in%20the%20background%2C%20tree-lined%20streets%20with%20classic%20American%20small%20town%20atmosphere%2C%20warm%20afternoon%20light%20illuminating%20well-preserved%20architecture%2C%20the%20Wood%20County%20courthouse%20district%20visible%2C%20professional%20photography%20with%20warm%20golden%20tones%20and%20welcoming%20community%20feel&width=1800&height=700&seq=bowling-green-oh-hero-001&orientation=landscape",
  heroImageAlt: "Bowling Green Ohio downtown with BGSU campus and historic brick architecture",
  geoPosition: "41.3748;-83.6513",
  geoPlacename: "Bowling Green, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 220 miles from Bowling Green via I-80",
  },
  nearbyCitiesZips: [
    { name: "Bowling Green", zips: "43402, 43403" },
    { name: "Perrysburg", zips: "43551, 43552" },
    { name: "Rossford", zips: "43460, 43461" },
    { name: "Northwood", zips: "43619" },
    { name: "Walbridge", zips: "43465" },
    { name: "Pemberville", zips: "43450" },
    { name: "Luckey", zips: "43443" },
    { name: "Haskins", zips: "43525" },
    { name: "Tontogany", zips: "43565" },
    { name: "Wayne", zips: "43466" },
    { name: "Portage", zips: "43451" },
    { name: "Grand Rapids", zips: "43522" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Bowling Green departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "BGSU Campus Coverage", desc: "Serving Wood County and the Bowling Green State University community" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Toledo, OH", route: "/cities/toledo" },
    { name: "Fast passport renewal in Findlay, OH", route: "/cities/findlay" },
    { name: "Emergency passport help in Lima, OH", route: "/cities/lima-oh" },
    { name: "Urgent passport services in Dayton, OH", route: "/cities/dayton" },
    { name: "Same-day passport help in Perrysburg, OH", route: "/perrysburg" },
    { name: "Passport courier services in Cleveland, OH", route: "/cities/cleveland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bowling Green remotely via secure courier. We do not have a walk-in office in Bowling Green — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wood County and the Bowling Green State University community.",
  fpcOfficeAddress: "127 Public Square, Cleveland, OH 44114",
  fpcOfficeDistance: "Serving all of Wood County and the surrounding northwest Ohio region",
  serviceAreaIntro: "From downtown Bowling Green to the Bowling Green State University campus, from Perrysburg and Rossford to Northwood and Walbridge — Fast Passport Center serves the entire Wood County region. We regularly help BGSU students, faculty, and residents from the Toledo suburbs get their passports fast.",
  nearbyCitiesIntro: "We serve all Bowling Green neighborhoods and the surrounding Wood County region including Perrysburg, Rossford, Northwood, Walbridge, Pemberville, Luckey, Haskins, Tontogany, Wayne, Portage, and Grand Rapids. If you are anywhere in the Bowling Green area or northwest Ohio, we have you covered.",
  howItWorksIntro: "Most Bowling Green travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Bowling Green travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Bowling Green and Wood County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Bowling Green? Here are the most common ones we hear from Wood County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Bowling Green international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer K.",
      location: "Bowling Green, OH",
      rating: 5,
      text: "As a BGSU professor preparing for a conference in Berlin, I needed my passport renewed fast. Fast Passport Center had it ready in 4 days. They were incredibly professional and communicative.",
      service: "Passport Renewal",
    },
    {
      name: "Chris T.",
      location: "Perrysburg, OH",
      rating: 5,
      text: "I thought I'd have to drive to Toledo or Cleveland for an emergency passport. Fast Passport Center handled everything from right here in Wood County. Got mine in 3 days.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda R.",
      location: "Rossford, OH",
      rating: 5,
      text: "My daughter's first passport for her BGSU study abroad program in Spain. Fast Passport Center guided us through every document and had it ready in 5 days. Perfect for college students.",
      service: "Child Passport",
    },
    {
      name: "Brian M.",
      location: "Northwood, OH",
      rating: 5,
      text: "Business trip to Toronto came up with only 5 days notice. They got me a passport in 4 business days. Professional team and I never had to leave northwest Ohio.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "bowling-green-oh-1",
      name: "Bowling Green Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "130 N Main St",
      city: "Bowling Green",
      state: "OH",
      zip: "43402",
      phone: "(419) 352-2141",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Bowling Green",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main downtown facility near BGSU campus. High volume during semester breaks — appointments strongly recommended. Serves all of Wood County.",
      icon: "ri-mail-line",
    },
    {
      id: "bowling-green-oh-2",
      name: "Perrysburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "130 W 3rd St",
      city: "Perrysburg",
      state: "OH",
      zip: "43551",
      phone: "(419) 874-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Perrysburg, 12 miles northeast of Bowling Green",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Wood County and southern Lucas County residents. Less crowded than Bowling Green. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "bowling-green-oh-3",
      name: "Rossford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 Lime City Rd",
      city: "Rossford",
      state: "OH",
      zip: "43460",
      phone: "(419) 666-2211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Rossford, 18 miles northeast of Bowling Green",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Wood County and southern Lucas County. Toledo suburb location.",
      icon: "ri-mail-line",
    },
    {
      id: "bowling-green-oh-4",
      name: "Northwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Wales Rd",
      city: "Northwood",
      state: "OH",
      zip: "43619",
      phone: "(419) 691-2711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Northwood, 20 miles northeast of Bowling Green",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Wood County and the Toledo metro area. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "bowling-green-oh-5",
      name: "Wood County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "1 Courthouse Sq",
      city: "Bowling Green",
      state: "OH",
      zip: "43402",
      phone: "(419) 354-9280",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Wood County Courthouse",
      website: "https://www.woodcountyohio.gov/",
      websiteLabel: "Wood County Government",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "bowling-green-oh-6",
      name: "Pemberville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "126 E Front St",
      city: "Pemberville",
      state: "OH",
      zip: "43450",
      phone: "(419) 287-3511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pemberville, 15 miles east of Bowling Green",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Wood County. Rural location with limited hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Bowling Green photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wood County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Bowling Green applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wood County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Bowling Green travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Bowling Green." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bowling Green address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Bowling Green before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Bowling Green for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — without the long drive to Chicago." },
    { q: "How fast can I renew my passport in Bowling Green?", a: "Fast Passport Center offers fast passport renewal in Bowling Green in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "I'm a BGSU student — can you help me get a passport for study abroad?", a: "Absolutely. Fast Passport Center regularly serves Bowling Green State University students and faculty preparing for study abroad, research trips, and international conferences. We understand the unique timeline pressures of academic travel and offer flexible processing options to meet your departure date." },
    { q: "Can I get a same-day passport appointment near Bowling Green?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 4 hours from Bowling Green — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Wood County residents." },
    { q: "Can I expedite a child passport in Bowling Green?", a: "Yes. Fast Passport Center expedites child passports in Bowling Green for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wood County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Bowling Green with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "What is the closest passport agency to Bowling Green?", a: "The nearest regional passport agency to Bowling Green is the Chicago Passport Agency, approximately 220 miles away via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Bowling Green without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Bowling Green", address: "1200 E Wooster St, Bowling Green, OH 43402", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Bowling Green", address: "1010 N Main St, Bowling Green, OH 43402", hours: "Mon-Sun: 7AM-11PM" },
    { name: "Walmart Supercenter — Bowling Green", address: "131 W Gypsy Lane Rd, Bowling Green, OH 43402", hours: "Mon-Sun: 6AM-11PM" },
    { name: "CVS Pharmacy — Perrysburg", address: "1060 Louisiana Ave, Perrysburg, OH 43551", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Perrysburg", address: "1065 Fremont Pike, Perrysburg, OH 43551", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Rossford", address: "100 Lime City Rd, Rossford, OH 43460", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walmart — Northwood", address: "1000 Woodville Rd, Northwood, OH 43619", hours: "Mon-Sun: 6AM-11PM" },
    { name: "CVS Pharmacy — Toledo", address: "3001 Navarre Ave, Toledo, OH 43605", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Wood County BMV — Bowling Green",
      address: "1400 E Wooster St, Bowling Green, OH 43402",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Lucas County BMV — Toledo",
      address: "4061 W Alexis Rd, Toledo, OH 43623",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Alternative for northern Wood County and southern Lucas County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Perrysburg License Bureau",
      address: "1040 Indiana Ave, Perrysburg, OH 43551",
      hours: "Mon-Fri: 8AM-4:30PM",
      note: "Serves eastern Wood County and Perrysburg area.",
      featured: false,
    },
    {
      name: "AAA — Bowling Green",
      address: "1215 E Wooster St, Bowling Green, OH 43402",
      hours: "Mon-Fri: 8AM-5:30PM, Sat: 9AM-12PM",
      note: "AAA members can renew licenses and access passport photo services at this location.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "TOL",
      name: "Toledo Express Airport",
      distance: "22 miles northeast of Bowling Green",
      address: "11013 Airport Hwy, Swanton, OH 43558",
      note: "Closest commercial airport to Bowling Green. Direct flights to major hubs including Chicago, Charlotte, and Orlando. Convenient for Wood County travelers.",
      flightUrl: "https://www.toledoexpress.com/",
      flightLabel: "Toledo Express Airport",
      featured: true,
    },
    {
      code: "DTW",
      name: "Detroit Metropolitan Wayne County Airport",
      distance: "55 miles north of Bowling Green",
      address: "1 Detroit Metro Airport, Detroit, MI 48242",
      note: "Major international hub with extensive domestic and international routes. Best option for long-haul international travel from northwest Ohio.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "Detroit Metro Airport",
      featured: false,
    },
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "110 miles east of Bowling Green",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Alternative for eastern Wood County residents. Major hub with international connections.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: false,
    },
  ],
};